import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Page = withSafeSuspense(
  lazy(
    async () => ({ default: ((await import('./page')).Page) })
  )
)
